import { StoreState } from '../types/store';

export const getAddInfoPopupSlice = (state: StoreState) => state.addInfoPopup;

export const getIsActive = (state: StoreState) =>
    getAddInfoPopupSlice(state).isActive;

export const getIsUserCanClosePopup = (state: StoreState) =>
    getAddInfoPopupSlice(state).isUserCanClosePopup;

export const getIsUserTryClosePopup = (state: StoreState) =>
    getAddInfoPopupSlice(state).isUserTryClosePopup;

export const getIsProTrialActivate = (state: StoreState) =>
    getAddInfoPopupSlice(state).isProTrialActivate;
